/**
 * Number Format
 *
 * Describes how numbers are formatted — specifically the choice of decimal
 * separator and thousands (grouping) separator.  Named after the convention
 * "{decimal}_{thousands}".
 *
 * Reference: https://en.wikipedia.org/wiki/Decimal_separator
 */
export const NumberFormat = {
  /**
   * 1,000.00 — period decimal, comma thousands
   * Countries: US, UK, CA, AU, IN, IE, MX, JP, CN, KR, …
   */
  PERIOD_COMMA: 'PERIOD_COMMA',

  /**
   * 1.000,00 — comma decimal, period thousands
   * Countries: DE, AT, NL, IT, ES, PT, DK, HR, RO, HU, …
   */
  COMMA_PERIOD: 'COMMA_PERIOD',

  /**
   * 1 000,00 — comma decimal, space (non-breaking) thousands
   * Countries: CZ, SK, FR, PL, SE, FI, NO, RU, UA, …
   */
  COMMA_SPACE: 'COMMA_SPACE',

  /**
   * 1 000.00 — period decimal, space (non-breaking) thousands
   * Countries: SE (alt), FI (alt), some Nordic/Swiss contexts
   */
  PERIOD_SPACE: 'PERIOD_SPACE',

  /**
   * 1'000.00 — period decimal, apostrophe thousands
   * Countries: CH (German/English context)
   */
  PERIOD_APOSTROPHE: 'PERIOD_APOSTROPHE',

  /**
   * 1'000,00 — comma decimal, apostrophe thousands
   * Countries: CH (French/Italian context)
   */
  COMMA_APOSTROPHE: 'COMMA_APOSTROPHE'
} as const;

export type NumberFormat = (typeof NumberFormat)[keyof typeof NumberFormat];
